module.exports = __webpack_public_path__ + "img/bullet-star-s.ad5707f9.svg";